export default "__VITE_ASSET__ce09d093__"